import { gsap } from 'gsap';
import Splitting from 'splitting';
import { loader } from '../utils/loader';
import { Power4 } from 'gsap';

const fadeInTween = () => ({
	set: { autoAlpha: 0 },
	to: { autoAlpha: 1 },
});

const fadeInUpTween = () => ({
	set: { autoAlpha: 0, y: '4px' },
	to: { autoAlpha: 1, y: '0' },
});

const revealTextTween = () => ({
	set: { alpha: 0, y: '150%' },
	to: {
		alpha: 1,
		ease: Power4.easeInOut,
		stagger: 200,
		y: 0,
	},
});

class Animated {
	/**
	 * Construct
	 *
	 * @description set state and cache elements.
	 */
	constructor(element) {
		/* Queries */
		this.element = element;
		this.title = element.querySelector('.rx-animated__title');
		this.lead = element.querySelector('.rx-animated__lead');

		if (!this.element) {
			return;
		}

		/* Initilize */
		this.init();
	}

	/**
	 * Init
	 *
	 * @description initialize.
	 */
	init() {
		/**
		 * Setup
		 */
		const result = Splitting({ target: this.title, by: 'lines', wrap: '<div class="line-wrapper"></div>' });

		// no title is present, so run the lead animation and return
		if (!result.length > 0) {
			gsap.set(this.lead, fadeInUpTween().set);
			gsap.timeline({ scrollTrigger: this.element, defaults: { duration: 1000 } })
				.to(this.lead, { ...fadeInUpTween().to, duration: 400 });

			return;
		}

		const lines = result[0].lines;

		lines.forEach((words) => {
			// overflow
			const overflow = document.createElement('div');
			overflow.classList.add('line-overflow');

			// animate
			const animate = document.createElement('div');
			animate.classList.add('line-animate');

			// words
			words.forEach((word, index) => {
				if (index === 0) {
					word.parentNode.appendChild(overflow);
					overflow.appendChild(animate);
				}

				animate.appendChild(word);

				// whitespace
				const whitespace = document.createElement('span');
				whitespace.classList.add('whitespace');
				whitespace.textContent = ' '; // Add a space
				animate.appendChild(whitespace);
			});
		});

		const titleLines = this.title.querySelectorAll('.line-animate');
		
		/**
		 * Timeline
		 */
		gsap.set(this.title, fadeInTween().set);
		gsap.set(this.lead, fadeInUpTween().set);
		gsap.set(titleLines, revealTextTween().set);

		gsap.to(this.title, fadeInTween().to);

		gsap.timeline({ scrollTrigger: this.element, defaults: { duration: 1000 } })
			.to(titleLines, revealTextTween().to)
			.to(this.lead, { ...fadeInUpTween().to, duration: 400 })
	}
}

/**
 * Create Hero
 */
export const createAnimated = () => {
	loader('.rx-animated', Animated);
};
